import { Skeleton } from '@forwardflow/ui-v2'

/**
 * Skeleton loader that mimics the PhoneNumbers grouped list layout.
 * Shows placeholder groups with area code headers and number items.
 */
export const PhoneNumbersSkeleton = ({
   groups = 3,
   itemsPerGroup = 2,
}: {
   groups?: number
   itemsPerGroup?: number
}) => {
   return (
      <div className="flex flex-col gap-y-6">
         {Array.from({ length: groups }).map((_, groupIndex) => (
            <div key={groupIndex} className="flex flex-col gap-y-2">
               {/* Group header: area code + locality + count */}
               <div className="flex items-center justify-between px-8">
                  <div className="flex items-center gap-x-2">
                     <Skeleton height={16} width={40} radius="sm" />
                     <Skeleton height={16} width={100} radius="sm" />
                  </div>
                  <Skeleton height={16} width={70} radius="sm" />
               </div>
               {/* Number items */}
               {Array.from({ length: itemsPerGroup }).map((_, itemIndex) => (
                  <div
                     key={itemIndex}
                     className="flex items-center justify-between bg-[#9061DA]/10 py-3 px-8"
                  >
                     <div className="flex flex-col gap-y-1">
                        <Skeleton height={16} width={130} radius="sm" />
                        <Skeleton height={14} width={90} radius="sm" />
                     </div>
                  </div>
               ))}
            </div>
         ))}
      </div>
   )
}

/**
 * Skeleton loader that mimics the pricing cards in ConfirmPurchaseNumbersModal.
 */
export const PricingCardsSkeleton = () => {
   return (
      <div className="space-y-3 mb-6">
         {Array.from({ length: 2 }).map((_, index) => (
            <div
               key={index}
               className="bg-[#9061DA]/20 rounded-lg p-4 flex items-center justify-between"
            >
               <div className="flex flex-col gap-y-1">
                  <Skeleton height={14} width={120} radius="sm" />
                  <Skeleton height={18} width={100} radius="sm" />
               </div>
               <Skeleton height={24} width={60} radius="sm" />
            </div>
         ))}
      </div>
   )
}
